module.exports = __webpack_public_path__ + "static/media/coin-total-up.e2aa065e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/coin-total-up.wav
// module id = 99
// module chunks = 0